import {BaseStore, globalStore} from "../../../stem-core/state/Store";
import {field} from "../../../stem-core/state/StoreField.js";
import {apiClient} from "../../connection/BlinkApiClient.js";
import {Merchant} from "../MerchantStore";
import {StemDate} from "../../../stem-core/time/Date";

interface EditMerchantSDKSettingsRequest {
    sdkSettingsId?: number;
    [key: string]: any;
}


@globalStore
export class MerchantSDKSettings extends BaseStore("MerchantSDKSettings", {dependencies: ["Merchant"]}) {
    declare id: number; // Versions are ordered by id, so narrow it from StoreId
    @field(Number) parentVersionId: number;
    @field("self") parentVersion: MerchantSDKSettings; // TODO @cleanup rename to parent
    @field("Merchant") merchant: Merchant;

    @field(Date) createdAt: StemDate;
    @field(Boolean) isMaster: boolean;
    @field(Boolean) isArchive: boolean;
    @field(String) key: string;
    @field(String) name: string;
    @field(String) description: string;

    @field(Object) options: any; // TODO JSON
}

// TODO @cleanup this is the working version. Should be name differently, it's not active.
export function getEditingOrLiveSettingsVersion(merchant: Merchant): MerchantSDKSettings {
    const sdkVersions = MerchantSDKSettings.filterBy({merchant}).sort((a, b) => b.id - a.id);
    return sdkVersions[0]; // The highest id one
}

export async function apiEditMerchantSDKSettings(data: EditMerchantSDKSettingsRequest): Promise<MerchantSDKSettings> {
    const response = await apiClient.post("/merchant/edit_sdk_settings", data);
    const objects = MerchantSDKSettings.load(response);
    if (objects.length <= 1) {
        return objects[0];
    }
    // We forked the published version of merchant settings with this request
    // Find the object that is part of the forked settings and has the expected
    // version parent.
    return objects.find(obj => obj.parentVersionId === data.sdkSettingsId);
}

export async function apiMerchantChangeSettingsVersionMaster(data: any): Promise<any> {
    return apiClient.post("/merchant/change_settings_version_master", data);
}

export async function apiMerchantDeleteSettingsVersion(data: any): Promise<any> {
    return apiClient.post("/merchant/delete_settings_version", data);
}
